import React from 'react';

import classes from './Paragraph.module.scss';


const Paragraph = ({content, author, windowSize}) => {
	
	return(
		<div className={`container ${classes.Paragraph}`}>
			<div className={`row`}>
				<div className={`col-lg-8 ${classes.Paragraph__content}`}>
            		<span dangerouslySetInnerHTML={{__html:content.copy}}/>
				</div>
			</div>
		</div>
	)

}

export default Paragraph;